import { connect } from 'react-redux'
import DatosCuenta from "./DatosCuenta";
import { bindActionCreators } from 'redux';
import * as DatosGeneralesActions from "../actions/Actions";
import * as DatosGeneralesCuentaActions from "../actions/DatosGeneralesCuentaActions" 
import * as SaldosMovimientosActions from "../actions/SaldosMovimientosActions"
import * as IntegrantesActions from "../actions/IntegrantesActions"
import * as BajaCuentaPrepagaActions from "../actions/BajaCuentaPrepagaActions"
import * as ActionsAutorizacionesRechazadas from "../actions/ActionsAutorizacionesRechazadas"
import * as IngresoAjustesActions from '../actions/IngresoAjustesActions'

const mapStateToProps = (state) => {
    return {
        data: state.DatosCuenta,
        ingresoAjustes : state.ingresoAjustes,
        tarjetas: state.tarjetas
    }
}


const mapDispatchToProps = (dispatch) =>{
     return {

      actions: bindActionCreators({...DatosGeneralesActions, ...DatosGeneralesCuentaActions, ...SaldosMovimientosActions, ...IntegrantesActions, ...BajaCuentaPrepagaActions, ...ActionsAutorizacionesRechazadas, ...IngresoAjustesActions}, dispatch)
     //    DatosCuentaActions: bindActionCreators(DatosGeneralesActions, dispatch),
      //   DatosGeneralesCuentaActions: bindActionCreators(DatosGeneralesCuentaActions, dispatch)
       }
   //return bindActionCreators(DatosGeneralesCuentaActions, dispatch)
}  
const DatosCuentaContainer = connect(mapStateToProps, mapDispatchToProps)(DatosCuenta);

export default DatosCuentaContainer;

